import $ from 'jquery'
import Toggler from 'luminate/src/modules/toggler'

export default function() {
	const $html = $('html');
	const $header = $('#header');
	const $window = $(window);
	const scrollClass = 'is-scrolling';

	function scrollCheck() {
		const scrollTop = $window.scrollTop();
		const hasClass = $header.hasClass(scrollClass);
		if (scrollTop > 0 && !hasClass) {
			$header.addClass(scrollClass);
		} else if(scrollTop === 0 && hasClass) {
			$header.removeClass(scrollClass);
		}
	}

	scrollCheck();
	$window.on('scroll', scrollCheck);

	(function initSearch() {
		const $search = $header.find('.header_search');
		const $searchWrapper = $search.find('.header_search_wrapper');
		const $searchField = $search.find('.header_search_field');
		const $searchButton = $search.find('.header_search_button');

		const toggler = $searchWrapper.data('toggler');

		toggler.on('open', () => $searchField.trigger('focus'));
		toggler.on('toggle', () => $header.toggleClass('is-search-open', toggler.isOpen()));

		$searchButton.on('click', function(e) {
			if (!toggler.isOpen()) {
				e.preventDefault();
				toggler.open();
				$searchField.focus();
			} else if($searchField.val() === '') {
				e.preventDefault();
			}
		});

		$search.on('click', (e) => e.stopPropagation());
		$html.on('click', () => toggler.close());

	}());
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js